














import { Component, Vue } from "vue-property-decorator";
import { CommonMudule } from "@/store/modules/common";

@Component({
  name: "",
})
export default class extends Vue {
  created() {}

  get compliancePicList(){
      return CommonMudule.imgSource.compliance.split(",") || [];
  }
}
